import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { WindowTimeStyled, WindowTimeText, WindowTimeBar, Progress } from './styled'

const WindowTime = ({ startTime, startTimeFormatted, endTime, endTimeFormatted }) => {
    const currentTime = moment().unix()

    const calcProgress = (start, end, current) => {
        const progress = ((current - start) / (end - start)).toFixed(2) * 100
        return progress < 0 ? 0 : progress > 100 ? 100 : progress
    }

    const setTimeFormat = (time, format) => moment.unix(time).format('HH:mm')

    return (
        <WindowTimeStyled>
            <WindowTimeText>
                {startTimeFormatted ? startTimeFormatted : setTimeFormat(startTime, 'HH:mm')}
            </WindowTimeText>
            <WindowTimeBar>
                <Progress progress={calcProgress(startTime, endTime, currentTime)} />
            </WindowTimeBar>
            <WindowTimeText>
                {endTimeFormatted ? endTimeFormatted : setTimeFormat(endTime, 'HH:mm')}
            </WindowTimeText>
        </WindowTimeStyled>
    )
}

WindowTime.propTypes = {
    windowTime: PropTypes.array,
    signal: PropTypes.number
}

WindowTime.defaultProps = {
    windowTime: [0, 0],
    signal: 0
};

export default WindowTime